
//
const calendarWrapper = document.querySelector('.mercury-calendar');

//
let allEvents = null

//
let thisdate = null;
let prevdate = null;
let nextdate = null;

//
let filters = { 'regions': [], 'hosts': [], 'types': [] };

//update the URL with current filters
function updateURLParams() {

    //
    const params = [];

    //
    filters.regions.forEach(region => { params.push(`regions[]=${encodeURIComponent(region).replace(/%20/g, '+')}`); });
    filters.hosts.forEach(host => { params.push(`hosts[]=${encodeURIComponent(host).replace(/%20/g, '+')}`); });
    filters.types.forEach(type => { params.push(`types[]=${encodeURIComponent(type).replace(/%20/g, '+')}`); });

    //
    window.history.pushState({}, '', window.location.origin + window.location.pathname + ((params.length) ? '?' + params.join('&') : ''));

}

//load filters from URL parameters
function loadFiltersFromURL() {

    //
    filters = { 'regions' : [], 'hosts' : [], 'types' : [] };

    //
    new URLSearchParams(window.location.search).forEach((value, key) => {
        if (filters.hasOwnProperty(key.substring(0, key.length - 2))) {

            //
            filters[key.substring(0, key.length - 2)].push(value.trim().toLowerCase());

            //
            document.querySelector(`.filter-item[data-region="${value.trim().toLowerCase()}"]`)?.setAttribute('data-selected', 'data-selected');
            document.querySelector(`.filter-item[data-rep="${value.trim().toLowerCase()}"]`)?.setAttribute('data-selected', 'data-selected');
            document.querySelector(`.filter-item[data-type="${value.trim().replace(' ', '-').toLowerCase()}"]`)?.setAttribute('data-selected', 'data-selected');

        }
    });

}

//
document.querySelectorAll('.calendar-filters details summary span').forEach(element => {
    element.addEventListener('click', event => {

        event.preventDefault();

        if (event.target.hasAttribute('data-filter') == true && event.target.dataset.filter == 'region') {
            filters.regions = applyHeadingFilter(event.target, filters.regions, 'region');
        }

        if (event.target.hasAttribute('data-filter') == true && event.target.dataset.filter == 'rep') {
            filters.hosts = applyHeadingFilter(event.target, filters.hosts, 'rep');
        }

        if (event.target.hasAttribute('data-filter') == true && event.target.dataset.filter == 'type') {
            filters.types = applyHeadingFilter(event.target, filters.types, 'type');
        }

        //
        filterEvents();

        //
        printEvents();
        updateURLParams();

    });
});

//initial setup of filters behaviour
document.querySelectorAll('.calendar-filters details div').forEach(element => {
    element.addEventListener('click', (event) => {
        const text = event.target.textContent.trim().toLowerCase();

        //
        if (event.target.hasAttribute('data-regionid') == true) {
            if (filters.regions.includes(text)) {
                filters.regions = filters.regions.filter(v => v !== text);
            } else {
                filters.regions.push(text);
            }
        }

        //
        if (event.target.hasAttribute('data-repid') == true) {
            if (filters.hosts.includes(text)) {
                filters.hosts = filters.hosts.filter(v => v !== text);
            } else {
                filters.hosts.push(text);
            }
        }

        //
        if (event.target.hasAttribute('data-type') == true) {
            if (filters.types.includes(text)) {
                filters.types = filters.types.filter(v => v !== text);
            } else {
                filters.types.push(text);
            }
        }

        //toggle the filters stuff - also add some special functions to the main heading
        if (event.target.hasAttribute('data-selected')) {
            event.target.removeAttribute('data-selected');
        } else {
            event.target.setAttribute('data-selected', 'data-selected')
        }

        //
        filterEvents();

        //
        printEvents();
        updateURLParams();

    });
});

function getCalendarEvents(data) {

    let formData = new FormData();
    formData.append('year', data.year);
    formData.append('month', data.month);

    //
    const promise = fetch('/api/get-calendar-events', {
        method: 'POST',
        body: formData,
    });

    //
    return promise.then((response) => response.json()).then((response) => response).catch((error) => {
        console.error(error);
    });

}

async function loadEvents(date) {

    //
    thisdate = date;

    //
    prevdate = thisdate.clone().subtract(1, 'month');
    nextdate = thisdate.clone().add(1, 'month');

    //update the title and buttons + address bar
    $('.mercury-calendar-header div h2 span').html(thisdate.format('MMMM YYYY'));

    // additional feature that allows for going straight to a calendar month via the url - temporarily disabled
    // history.pushState({}, '', '/events/meetings/' + thisdate.format('YYYY-MM'));

    $('.mercury-calendar-header button[data-action="show-prev-month"]').data('date', prevdate).find('span').html(prevdate.format('MMMM YYYY'));
    $('.mercury-calendar-header button[data-action="show-next-month"]').data('date', nextdate).find('span').html(nextdate.format('MMMM YYYY'));

    //
    let data = {
        'year': thisdate.format('YYYY'),
        'month': thisdate.format('MMMM').toLowerCase()
    };

    console.log(filters);

    //
    response = await getCalendarEvents(data);
    allEvents = response.details;

    //
    filterEvents();

    //
    printEvents();

}

//
function applyHeadingFilter(element, filterArray, filterName) {

    //
    let children = Array.from(element.closest('details').querySelectorAll('.filter-item'));

    filterArray = [];

    //if some or no filters are selected, select all
    if (filterArray.length < children.length) {
        children.forEach((v, k) => {
            switch (filterName) {
                case 'region': filterArray.push(v.textContent.trim().toLowerCase()); break;
                case 'rep':    filterArray.push(v.textContent.trim().toLowerCase()); break;
                case 'type':   filterArray.push(v.textContent.trim().toLowerCase()); break;
            }
        });
    }

    //
    if (filterArray.length == children.length && element.hasAttribute('data-selected') == false) {
        element.setAttribute('data-selected', 'data-selected');
        children.forEach((v, k) => v.setAttribute('data-selected', 'data-selected'));
    } else {
        filterArray = [];
        element.removeAttribute('data-selected');
        children.forEach((v, k) => v.removeAttribute('data-selected'));
    }

    updateURLParams();

    return filterArray

}

//apply any filters to the current events
function filterEvents() {

    //
    allEvents = allEvents.map((event) => {

        //
        event.filters = [];

        //
        if (filters.regions.length > 0) {
            event.filters.push((filters.regions.indexOf(event.region.toLowerCase()) != -1));
        }

        //
        if (filters.hosts.length > 0) {
            event.filters.push((filters.hosts.indexOf(event.trainerName.toLowerCase()) != -1));
        }

        //
        if (filters.types.length > 0) {
            event.filters.push((filters.types.indexOf(event.venueType.replace('-', ' ').toLowerCase()) != -1));
        }

        //
        return event;

    });

}

//
function printEvents() {

    //
    const calendarWrapper = document.querySelector('.mercury-calendar-wrapper');
    calendarWrapper.innerHTML = '';

    //if an event does not match the filter - "disable" it
    allEvents.forEach((event) => {
        event.disabled = !(typeof event.filters === 'undefined' || event.filters.every((v) => v === true));
    });

    //if true, show mobile design else show the tablet and above design
    displayEventList(allEvents);

}

//
function displayEventList(events) {

    //don't show "disabled" events in the list view
    events = events.filter((event) => !event.disabled);

    //
    dayjs.locale('en');

    //display events as a list
    const calendarWrapper = document.querySelector('.mercury-calendar-wrapper');
    calendarWrapper.innerHTML = zeno_template('tpl-calendar-list-view', {
        'events' : events,
    });

    //attach an event to close the other details elements when opening one
    const eventElements = document.querySelectorAll('.calendar-list-view-event');
    eventElements.forEach((eventElement) => {
        eventElement.addEventListener('click', (event) => {
            eventElements.forEach((el) => {
                if (el !== eventElement) {
                    el.removeAttribute('open');
                }
            });
        });

    });

}

$('.mercury-calendar-header').on('click', 'button[data-action="show-prev-month"]', zeno_debounce(200, function(event) {
    loadEvents($(this).data('date'));
}));

$('.mercury-calendar-header').on('click', 'button[data-action="show-next-month"]', zeno_debounce(200, function(event) {
    loadEvents($(this).data('date'));
}));

//------------------------------------------------------------------------------

//
dayjs.locale('en');

loadFiltersFromURL();  //load initial filters from URL parameters
loadEvents(dayjs(calendarWrapper.dataset.selectedDate));

//------------------------------------------------------------------------------

//
let isInSmallViewportMode = false;

//
const closeFilters = () => {

    //moving from small to large viewport
    if (isInSmallViewportMode && window.innerWidth > 700) {
        isInSmallViewportMode = false;
    }

    //moving from large to small
    if (!isInSmallViewportMode && window.innerWidth < 700) {

        //
        document.querySelectorAll('.calendar-filters details').forEach(element => {
            element.removeAttribute('open');
        });

        //
        isInSmallViewportMode = true;

    }

};

//
window.addEventListener('resize', closeFilters);
closeFilters();

//------------------------------------------------------------------------------